import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_SETTINGS, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { UserProfileService } from '../user-profile.service';
import { NgIf, NgStyle, NgClass } from '@angular/common';
import { IMaskDirective } from 'angular-imask';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-account-recovery',
    templateUrl: './account-recovery.component.html',
    styleUrls: ['./account-recovery.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        IMaskDirective,
        NgStyle,
        NgClass,
        RouterLink,
    ],
})
export class AccountRecoveryComponent implements OnInit, OnDestroy {

  screenWidth: number;

  public userForm = new UntypedFormGroup({});
  public phoneMask = {mask: '(000) 000-0000'};
  public user: any;
  private subscription: ISubscription[];
  public toggleEditStyles = {};
  APP_SETTINGS:any;
  public phone = new UntypedFormControl('');
  public email = new UntypedFormControl('');

  constructor(
    private fb: UntypedFormBuilder, 
    private userProfileService: UserProfileService, 
    private utilityService: UtilityService
    ) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    this.subscription.push(this.userProfileService.getUsersInfoByEmail('abubakar.mujawar@partner.bmwgroup.com').subscribe(data => {
      this.user = data;
      this.phone = new UntypedFormControl(this.user.phone, Validators.required);
      this.email = new UntypedFormControl(this.user.email, Validators.required);
      this.userForm = this.fb.group({
        phone: this.phone,
        email: this.email
      });
    }));
  }
  onSubmit() {
    this.user = {...this.user, ...this.userForm.value};
    this.subscription.push(this.userProfileService.updateUserInfo(this.userForm.value).subscribe());
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

}
